export default __webpack_public_path__ + "static/media/arrow.bc21a0f1.svg";